<template>
  <div class="BlogHeader">

    <break size="3" />

    <div class="BlogHeader-header">

      <title-location class="BlogHeader-titleLocation"
        title="Storer Creek Stories"
        title-route="/storer-creek"
        :location="location" />

      <nav class="BlogHeader-yearPicker">

        <blog-year-selector :years="years" />

      </nav>

    </div>

    <rule />

  </div>
</template>

<script>
export default {
  name: 'BlogHeader',

  props: {
    years: {
      type: Array
    },
    location: {
      type: String
    }
  }
}
</script>

<style>
.BlogHeader-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 15px;
}

.BlogHeader-yearPicker {
  display: none;

  @media (min-width: 680px) {
    display: block;
  }
}

.BlogHeader-yearPicker > * {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// BlogHeader.vue?637b372e